import React, {useContext} from 'react'
import { Typography, FormControlLabel, Radio } from '@mui/material'
import productTypeIsOneOf from '../../../lib/productTypeIsOneOf'
import { ProductTypeOptions } from '../../../contexts/types'
import {Trans} from "react-i18next";
import {OrgCustomizationContext} from "../../../themes/OrgCustomizationProvider";

type MRICompatibilityOptionsProps = {
    productType: ProductTypeOptions
}

const MRICompatibilityOptions: React.FC<MRICompatibilityOptionsProps> = ({
    productType,
}) => {
    const {t, tns} = useContext(OrgCustomizationContext)
    
    return (
        <>
            {/* MRI Compatibility */}
            <Typography
                variant='body1'
                color='secondary.contrastText'
                sx={{ pt: 2 }}
            >
                <Trans i18nKey={tns('cti_complaint_mri_combatibility')}>
                    -
                    <Typography component='span' sx={{ color: 'primary.main' }}>
                        -
                    </Typography>
                    -
                </Trans>
            </Typography>

            {productTypeIsOneOf(
                ['IMPLANT', 'ABUTMENT', 'SCREW'],
                productType
            ) && (
                <FormControlLabel
                    value='ARTIFIACTS_ON_IMAGE'
                    control={<Radio />}
                    label={t('cti_option_artifiacts_on_image') as string}
                />
            )}

            {productTypeIsOneOf(
                ['IMPLANT', 'ABUTMENT', 'SCREW'],
                productType
            ) && (
                <FormControlLabel
                    value='DEFLECTION'
                    control={<Radio />}
                    label={t('cti_option_deflection') as string}
                />
            )}

            {productTypeIsOneOf(
                ['IMPLANT', 'ABUTMENT', 'SCREW'],
                productType
            ) && (
                <FormControlLabel
                    value='HEATING'
                    control={<Radio />}
                    label={t('cti_option_heating') as string}
                />
            )}
        </>
    )
}

export default MRICompatibilityOptions
